import React, { useState, useEffect, useContext, useRef } from "react";
import { Tooltip } from "react-tippy";
import Lottie from "lottie-web";
import MyContext from "../../../context/MyContext";
import ProjectContext from "../../../context/ProjectContext";
import TickerContext from "../../../context/ticker";
import AuthContext from "../../../context/userAuth.context";
import GuidesOptions from "./guidesOptions";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import BackgroundMusicModal from "./BackgroundMusicModal";
import axios from "axios";
import BgMusicPanel from "./bgMusicPanel";
export const TimelineSetting = (props) => {
  const {
    CanvasDisplay,
    setCanvasDisplay,
    changeTimelineZoomVal,
    setLayersData,
    LayersData,
    timelineZoomVal,
    clone,
    UndoLayer,
    RedoLayer,
    setRedoLayer,
    TimelineUndo,
    setUndoLayer,
    setEditorZoom,
    EditorZoom,
    setChangeCount,
    ChangeCount,
    setIsPlayClicked,
    isPlayClicked,
    setcheckFunction,
    Tl_TotalTime,
    pauseState,
    setpauseState,
    setMultiDrag,
    showRecording,
    setshowRecording,
    seteditableObject,
    previousLayersData,
    setPreviousLayersData,
  } = useContext(MyContext);

  const {
    setTickerPosition,
    TickerPosition,
    setTickerStart,
    ReverseLayer,
    setReverseLayer,
    setClick_TickerPosition,
    TickerRef,
    TickerState,
    setTickerState,
  } = useContext(TickerContext);

  const { authenticationData } = useContext(AuthContext);
  const { setbgmusicState, bgmusicState, slides } = useContext(ProjectContext);

  const pauseRef = useRef(null);
  const playRef = useRef(null);
  const [renderCount, setRenderCount] = useState(0);
  const handleChange = (e) => {
    changeTimelineZoomVal(e.target.value);
  };

  useEffect(() => {
    if (!CanvasDisplay) {
      setpauseState(true);
    } else if (CanvasDisplay) {
      setpauseState(false);
    }
  }, [CanvasDisplay]);

  const calculateTimeByWidth = (width) => {
    let ms = parseFloat(
      (width * localStorage.getItem("onePxEquivalent")).toFixed(3)
    );
    return ms;
  };

  const calculatePreviousSlidesSeconds = (duration) => {
    var tempArr = duration.split(":");
    var hours = parseInt(tempArr[0]);
    var minutes = parseInt(tempArr[1]);
    var seconds = parseInt(tempArr[2]);
    var milliseconds = parseInt(tempArr[3]);
    var totalMilliseconds =
      (hours * 60 * 60 + minutes * 60 + seconds) * 1000 + milliseconds;
    return totalMilliseconds / 1000;
  };
  const playBgMusicWithTicker = () => {
    try {
      var previousSlideTime = 0;
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].IsActive === true) {
          for (let j = 0; j <= i - 1; j++) {
            previousSlideTime =
              previousSlideTime +
              calculatePreviousSlidesSeconds(slides[0].TotalLength);
          }
        }
      }

      var currentSlideTimeSECONDS = calculateTimeByWidth(TickerPosition) / 1000;
      var previousSlideTimeSECONDS = previousSlideTime;
      var element = document.getElementById("bgmusicAudioPlayer");
      element.src = authenticationData.ApiBaseURL + "/" + bgmusicState.src;
      element.volume = bgmusicState.volume / 100;
      if (
        bgmusicState.duration >
        previousSlideTimeSECONDS + currentSlideTimeSECONDS
      ) {
        element.currentTime =
          previousSlideTimeSECONDS + currentSlideTimeSECONDS;
        element.play();
      }
    } catch (exp) {
      console.log("Error in playBgMusicWithTicker", exp);
    }
  };
  const stopBgMusicWithTicker = () => {
    try {
      var element = document.getElementById("bgmusicAudioPlayer");
      //element.src = authenticationData.ApiBaseURL + "/" + bgmusicState.src;
      element.pause();
    } catch (exp) {
      console.log("Error in stopBgMusicWithTicker", exp);
    }
  };

  const display = (e) => {
    seteditableObject({ showPanel: false, editableItem: [] });
    playBgMusicWithTicker();
    const data = Lottie.getRegisteredAnimations();
    LayersData.map((value) => {
      value.ComingFromToolbar = true;
      value.player = false;
      data.map((LottieData) => {
        if (LottieData.name == value.AnimationId) {
          Lottie.destroy(value.AnimationId);
        }
      });
    });
    setMultiDrag([]);
    //Doing this to fix jerk on Start from Play
    setcheckFunction(false);
    setIsPlayClicked(true);
    setCanvasDisplay(false);
    setpauseState(true);

    document.getElementsByClassName("body")[0].focus();
  };

  const pause = (e) => {
    stopBgMusicWithTicker();
    //Doing this to fix jerk on Start from Play
    setcheckFunction(false);
    LayersData.map((value) => {
      value.ComingFromToolbar = true;
    });
    setIsPlayClicked(false);
    setCanvasDisplay(true);
    setpauseState(false);
    document.getElementsByClassName("body")[0].focus();
  };

  const ZoomOut = (params) => {
    if (EditorZoom > 50) {
      const array = Array.from(LayersData);
      if (array.length != 0) {
        let check = false;
        for (var i = 0; i < array.length; i++) {
          if (array[i].Editable) {
            array[i].Editable = false;
            check = true;
          }
        }
        if (check) {
          setLayersData(array);
        }
      }
      setEditorZoom(EditorZoom - 10);
    }
  };

  const ZoomIn = () => {
    if (EditorZoom < 150) {
      const array = Array.from(LayersData);
      if (array.length != 0) {
        let check = false;
        for (var i = 0; i < array.length; i++) {
          if (array[i].Editable) {
            array[i].Editable = false;
            check = true;
          }
        }
        if (check) {
          setLayersData(array);
        }
      }
      setEditorZoom(EditorZoom + 10);
    }
  };

  const redo = () => {
    var Undostack = [...UndoLayer];
    var CurrentArray = clone(LayersData);
    var redoArray = [...RedoLayer];

    if (redoArray.length != 0) {
      var pop = redoArray.pop();

      setRedoLayer(redoArray);
      Undostack.push(CurrentArray);
      setUndoLayer(Undostack);
      setLayersData(pop);

      let poparray = JSON.parse(JSON.stringify(pop));
      if (poparray.length != 0) {
        if (poparray[0].TimelineZoom) {
          TimelineUndo(poparray[0].TimelineZoom);
        }
      }
      const updatedReverseLayer = ReverseLayer.map((reverseLayerItem) => {
        const correspondingLayerData = pop.find((layerDataItem) => layerDataItem.Name === reverseLayerItem.Name);
        return correspondingLayerData ? { ...correspondingLayerData } : reverseLayerItem;
      });
      setReverseLayer(updatedReverseLayer);
    }

    setChangeCount(ChangeCount + 1)
  };

  const undo = () => {
    var stack = [...UndoLayer];
    var CurrentArray = clone(LayersData);
    var redoArray = [...RedoLayer];
    if (stack.length != 0) {
      var pop = stack.pop();
      setUndoLayer(stack);
      redoArray.push(CurrentArray);
      setRedoLayer(redoArray);

      let poparray;

      if (stack.length >= 0) {
        let arr = [];

        for (let pl = 0; pl < pop.length; pl++) {
          arr.push(pop[pl]);
        }

        arr.map((item) =>{
          item.Editable = false

        })
        setLayersData(arr);
        const updatedReverseLayer = ReverseLayer.map((reverseLayerItem) => {
          const correspondingLayerData = arr.find((layerDataItem) =>
           layerDataItem.Name === reverseLayerItem.Name);
          return correspondingLayerData ? { ...correspondingLayerData } : reverseLayerItem;
        });
        setReverseLayer(updatedReverseLayer);
        // setPreviousLayersData(arr)
        poparray = JSON.parse(JSON.stringify(arr));
      }
      //  else {
      //   setLayersData([]);
      //   poparray = JSON.parse(JSON.stringify(pop));
      // }

      if (poparray && poparray.length != 0) {
        if (poparray[0].TimelineZoom) {
          TimelineUndo(poparray[0].TimelineZoom);
        } else {
          TimelineUndo(3);
        }
      }
      seteditableObject({ showPanel: false, editableItem: [] });

      //setChangeCount(ChangeCount - 1)
    }
  };

  useEffect(() => {
    if (pauseState) {
      pauseRef.current.focus();
    }
  }, [pauseState]);

  const [guideOpen, setguideOpen] = useState(false);
  const [bgmusicModal, setbgmusicModal] = useState(false);
  const [bgMusicList, setbgMusicList] = useState({});

  const GetbgmusicAndOpenModal = () => {
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    axios
      .get(authenticationData.ApiBaseURL + "/api/Character/GetSounds", {
        headers: {
          "Content-Type": `multipart/form-data`,
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      })
      .then((response) => {
        if (response.data.status === true) {
          if (response.data.type === "admin") {
            const DataArray = response.data.sounds;
            setSoundsData({
              userData: [],
              adminData: DataArray,
            });
          } else if (response.data.type === "user") {
            const DataArray = response.data.sounds;
            if (
              response.data.userSounds != undefined &&
              response.data.userSounds != null
            ) {
              setbgMusicList({
                userData: response.data.userSounds,
                adminData: DataArray,
              });
            } else {
              setbgMusicList({
                userData: [],
                adminData: DataArray,
              });
            }
          }
          setbgmusicModal(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="timelineSettings">
      <audio controls id="bgmusicAudioPlayer" style={{ display: "none" }}>
        <source src="" type="audio/mp3" />
      </audio>
      <div className="TimelineZoomWrapper">
        <div className="tmZoom">
          <span
            className="material-icons rangeIcon"
            onClick={() => {
              if (timelineZoomVal > 0 && timelineZoomVal <= 6)
                changeTimelineZoomVal(timelineZoomVal - 1);
            }}
          >
            remove
          </span>
          <Tooltip
            title="Timeline Resize"
            position="top"
            trigger="mouseenter"
            theme="transparent"
            arrow={true}
            animation="scale"
            size="small"
          >
            <input
              className="Timelineslider range"
              id="timeline_zoomer"
              type="range"
              min="0"
              max="6"
              value={timelineZoomVal}
              onInput={handleChange}
            />
          </Tooltip>
          <span
            className="material-icons rangeIcon"
            onClick={() => {
              if (timelineZoomVal >= 0 && timelineZoomVal < 6)
                changeTimelineZoomVal(timelineZoomVal + 1);
            }}
          >
            add
          </span>
        </div>

        <div className="EditorZoomWrapper">
          <div className="hoverIconTimeline" onClick={() => ZoomOut()}>
            <Tooltip
              title="Zoom out canvas"
              position="top"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
            >
              <img
                className="timelinePlayerIconsNormal"
                src="../AppIcons/IconsAll/zoomOut.svg"
                alt=""
              />
              <img
                className="timelinePlayerIconsHover"
                src="../AppIcons/IconsAll/zoomOut_hover.svg"
                alt=""
              />
            </Tooltip>
          </div>

          <div className="zoomText">
            <span>{EditorZoom + "%"}</span>
          </div>

          <div className="hoverIconTimeline" onClick={() => ZoomIn()}>
            <Tooltip
              title="Zoom in canvas"
              position="top"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
            >
              <img
                className="timelinePlayerIconsNormal"
                src="../AppIcons/IconsAll/zoomIn.svg"
                alt=""
              />
              <img
                className="timelinePlayerIconsHover"
                src="../AppIcons/IconsAll/zoomIn_hover.svg"
                alt=""
              />
            </Tooltip>
          </div>
        </div>

        <div className="guidesWrapper">
          <button
            className="btn btn-grey btn-small"
            onClick={() => setguideOpen(true)}
          >
            Guides
          </button>
        </div>
      </div>
      {
        <GuidesOptions
          setguideOpen={setguideOpen}
          open={guideOpen}
        ></GuidesOptions>
      }
      <div className="PlayerTools">
        <div className="d-flex" style={{ alignItems: "center" }}>
          <div className="hoverIconTimeline" onClick={undo}>
            <Tooltip
              title="Undo"
              position="top"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
            >
              <img
                className="timelinePlayerIconsNormal"
                src="../AppIcons/IconsAll/undo.svg"
                alt=""
              />
              <img
                className="timelinePlayerIconsHover"
                src="../AppIcons/IconsAll/undo_hover.svg"
                alt=""
              />
            </Tooltip>
          </div>

          <div className="hoverIconTimeline" onClick={redo}>
            <Tooltip
              title="Redo"
              position="top"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
            >
              <img
                className="timelinePlayerIconsNormal"
                src="../AppIcons/IconsAll/redo.svg"
                alt=""
              />
              <img
                className="timelinePlayerIconsHover"
                src="../AppIcons/IconsAll/redo_hover.svg"
                alt=""
              />
            </Tooltip>
          </div>

          <div className="Iconsections">
            <div
              className="hoverIconTimeline"
              onClick={() => {
                setTickerPosition(0);
                setTickerState(0);
                setClick_TickerPosition(0);
                setIsPlayClicked(false);
                //Doing this to fix jerk on Start from Play
                setcheckFunction(true);
              }}
            >
              <Tooltip
                title="Go to start"
                position="top"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
              >
                <img
                  className="timelinePlayerIconsNormal"
                  src="../AppIcons/IconsAll/tickerStart.svg"
                  alt=""
                />
                <img
                  className="timelinePlayerIconsHover"
                  src="../AppIcons/IconsAll/tickerStart_hover.svg"
                  alt=""
                />
              </Tooltip>
            </div>

            <span
              onClick={display}
              // ref={playRef}
              style={{ display: pauseState === false ? "block" : "none" }}
            >
              <Tooltip
                title="Play from playhead"
                position="top"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
              >
                <div className="videoPlayer hoverPlayIconTimeline">
                  <img
                    className="playVideoIconNormal"
                    src="../AppIcons/IconsAll/playVideo.svg"
                    alt=""
                  />
                  <img
                    className="playVideoIconHover"
                    src="../AppIcons/IconsAll/playVideo_hover.svg"
                    alt=""
                  />
                </div>
              </Tooltip>
            </span>

            <span
              id="pauseRef"
              tabIndex="1"
              onClick={pause}
              ref={pauseRef}
              onBlur={pause}
              style={{ display: pauseState === true ? "block" : "none" }}
            >
              <Tooltip
                title="Pause video"
                position="top"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
              >
                <div className="videoPlayer ">
                  <img
                    className="playVideoIconNormal"
                    src="../AppIcons/IconsAll/pauseVideo.svg"
                    alt=""
                  />
                </div>
              </Tooltip>
            </span>

            <div
              className="hoverIconTimeline"
              onClick={() => {
                setTickerPosition(Tl_TotalTime.width);
                setTickerState(Tl_TotalTime.width);
                setClick_TickerPosition(Tl_TotalTime.width);
                //Doing this to fix jerk on Start from Play
                setcheckFunction(false);
              }}
            >
              <Tooltip
                title="Go to end"
                position="top"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
              >
                <img
                  className="timelinePlayerIconsNormal"
                  src="../AppIcons/IconsAll/tickerEnd.svg"
                  alt=""
                />
                <img
                  className="timelinePlayerIconsHover"
                  src="../AppIcons/IconsAll/tickerEnd_hover.svg"
                  alt=""
                />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      <div className="rightTools">
        <div className="btn-group mr-2">
          {bgmusicState.src != "" && (
            <div
              className="btn btn-publish btn-black-outlined bgVolumeButton"
              style={{
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
                height: "32px",
              }}
            >
              <span
                style={{
                  fontSize: "22px",
                  position: "relative",
                  top: "0px",
                }}
                className="material-icons material-icons-outlined bgIcon"
              >
                volume_up
              </span>
              <div className="BgvolumeSlider">
                <InputRange
                  maxValue={100}
                  minValue={0}
                  value={bgmusicState.volume}
                  onChange={(value) =>
                    setbgmusicState({
                      ...bgmusicState,
                      volume: value,
                    })
                  }
                />
                {/* Ducking: the music goes down to 30% while characters speak (editor, preview, export) */}
                <label
                  title="The music goes down while characters speak"
                  style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 11, marginTop: 6, whiteSpace: "nowrap", cursor: "pointer" }}
                >
                  <input
                    type="checkbox"
                    checked={!!bgmusicState.duck}
                    onChange={(e) => setbgmusicState({ ...bgmusicState, duck: e.target.checked ? 0.3 : 0 })}
                  />
                  Lower while characters speak
                </label>
              </div>

              {/* 
              <div className="bgmusicPanel">
                <label className="mb-2">Background music volume</label>
                <InputRange
                  maxValue={100}
                  minValue={0}
                  value={bgmusicState.volume}
                  onChange={(value) =>
                    setbgmusicState({
                      ...bgmusicState,
                      volume: value,
                    })
                  }
                />
              </div> */}
            </div>
          )}

          <button
            style={{
              borderTopLeftRadius: bgmusicState.src != "" ? "0px" : "5px",
              borderBottomLeftRadius: bgmusicState.src != "" ? "0px" : "5px",
            }}
            className="btn btn-publish btn-black"
            onClick={() => GetbgmusicAndOpenModal()}
          >
            Background Music
          </button>
        </div>

        {/* {
          <div className="bgmusicPanel">
            <BgMusicPanel></BgMusicPanel>
          </div>
        } */}
        {bgmusicModal && (
          <BackgroundMusicModal
            setbgmusicState={setbgmusicState}
            bgmusicState={bgmusicState}
            bgMusicList={bgMusicList}
            setbgmusicModal={setbgmusicModal}
            bgmusicModal={bgmusicModal}
          ></BackgroundMusicModal>
        )}
        {!showRecording && (
          <button
            className="btn btn-publish btn-blue"
            onClick={() => setshowRecording(true)}
          >
            Record Voiceover
          </button>
        )}
      </div>
    </div>
  );
};

export default TimelineSetting;
